import { useMemo } from 'react';
import { SEARCH_QUERY as PUBLIC_SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationPublicRpc.dfc.new';
import { SEARCH_QUERY } from '../../../__generated__/chirp/com/hubspot/marketplace/personalization/rpc/PersonalizationRpc.dfc.new';
import { usePersonalizationQuery } from '../../hooks/usePersonalizationQuery';
import { STRING_FILTER_TYPENAME } from '../constants/find-partner-match';
export function useGetPartnerCount(selectedService) {
  var _countData$result$tot, _countData$result;
  const countFilter = useMemo(() => {
    const filtersByField = {
      PRODUCT_TYPE: [{
        values: ['SOLUTIONS_PARTNER_PROFILE'],
        negation: false,
        clause: 'OR',
        __typename: STRING_FILTER_TYPENAME
      }]
    };
    if (selectedService) {
      filtersByField.PROFILE_CATALOG_SERVICES = [{
        values: [selectedService],
        negation: false,
        clause: 'OR',
        __typename: STRING_FILTER_TYPENAME
      }];
    }
    return {
      filterGroups: [{
        filtersByField,
        clause: 'AND',
        negation: false
      }],
      clause: 'AND',
      negation: false
    };
  }, [selectedService]);
  const {
    data: countData
  } = usePersonalizationQuery({
    app: SEARCH_QUERY,
    public: PUBLIC_SEARCH_QUERY,
    options: {
      variables: {
        filter: countFilter,
        length: 0,
        offset: 0
      }
    }
  });
  return (_countData$result$tot = countData === null || countData === void 0 || (_countData$result = countData.result) === null || _countData$result === void 0 ? void 0 : _countData$result.total) !== null && _countData$result$tot !== void 0 ? _countData$result$tot : 0;
}